import comp from "./SearchBar";
export default comp;
